// this file was prevaled
/**
 * Build config: configuration set at build time.
 * @module soapbox/build_config
 */module.exports={"NODE_ENV":"production","BACKEND_URL":"","FE_SUBDIRECTORY":"/","FE_BUILD_DIR":"static","FE_INSTANCE_SOURCE_DIR":"instance","SENTRY_DSN":"https://341951a6e21a4c929c321aa2720401f5@o993038.ingest.sentry.io/5985154"};